import type { ReactNode } from "react";

export function Hero({
  eyebrow,
  title,
  subhead,
  actions,
  media,
}: {
  eyebrow?: string;
  title: ReactNode;
  subhead: ReactNode;
  actions?: ReactNode;
  media?: ReactNode;
}) {
  return (
    <div className="grid items-center gap-10 lg:grid-cols-2">
      <div>
        {eyebrow ? (
          <p className="mb-3 text-sm font-semibold uppercase tracking-wide text-brand-700">
            {eyebrow}
          </p>
        ) : null}
        <h1 className="text-4xl font-bold leading-[1.05] tracking-tight text-ink sm:text-5xl lg:text-6xl">
          {title}
        </h1>
        <p className="mt-5 max-w-2xl text-lg leading-relaxed text-muted sm:text-xl">{subhead}</p>
        {actions ? <div className="mt-8 flex flex-wrap items-center gap-3">{actions}</div> : null}
      </div>
      {media ? <div className="min-w-0">{media}</div> : null}
    </div>
  );
}
